import { render, staticRenderFns } from "./Chatboard.vue?vue&type=template&id=d9edf3ca&scoped=true&"
import script from "./Chatboard.vue?vue&type=script&lang=js&"
export * from "./Chatboard.vue?vue&type=script&lang=js&"
import style0 from "./Chatboard.vue?vue&type=style&index=0&id=d9edf3ca&lang=scss&scoped=true&"
import style1 from "./Chatboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9edf3ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCard})
